export default __webpack_public_path__ + "static/media/Group 34421.18d37927.png";